import "./index.scss";
import { useContext, useEffect, useState } from "react";
import { Modal } from "../Modal";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { CustomContainer,ScreenTitle,FlexRow,AppText,FlexColumn,Button} from "src/style";
import { Users } from "src/assets/icon";
import { Select } from "../Select";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useNavigate } from "react-router-dom";
import { getClassList, getAllMemberInClass } from "src/utils/helpers";
import helpers from "src/utils/helpers";

export const UserProfileModal = () => {
  const [memberClass, setMemberClass] = useState({ class: "" });
  const [student, setStudent] = useState({ member: '' });
  const { visibility, setModal,notifier } = useContext(VisibilityContext);
  const { API } = useContext(ApiContext);
  const navigate = useNavigate();
  const {
    info: { allMembers },
    setSelectedMember,
    info,
  } = useContext(AppInfoContext);
  const classList = getClassList(info);
  const memberList = getAllMemberInClass(info, memberClass.class);

  const handleCancel = () => {
    setMemberClass({ class: "" });
    setModal({ key: "showUserProfileModal", value: false });
  };

  const handleSubmit = async () => {
    const validation = helpers.inputValidator({...memberClass, ...student})
    if(!validation.isValidated) return notifier.show(validation.message, "Validation Reponse" )
    setModal({ key: "showUserProfileModal", value: false });
    navigate(`/dashboard/profile`);
  };
  const handleSelect = (key: string, value: string) => {
    setMemberClass({ ...memberClass, [key]: value });
  };
  const handleClassSelect = (key: string, value: string) => {
    setStudent({ ...student, [key]: value });
    setSelectedMember(value);
  };

  return (
    <Modal
      isOnMenu
      cancel={handleCancel}
      open={visibility.showUserProfileModal}
      className="user-profile-modal"
    >
      <ScreenTitle color="#712126" textSize="2.4" bottomMargin="3">
        User Profile
      </ScreenTitle>

      <FlexColumn gap=".3">
        <Select
          label="Class"
          list={classList}
          handleSelect={handleSelect}
          placeholder="Select Member Class"
          height="20rem"
          name="class"
        />

        <Select
          label="Member"
          list={memberList}
          handleSelect={handleClassSelect}
          placeholder="Select Member"
          Icon={<Users />}
          height="13rem"
          name="member"
        />
      </FlexColumn>

      <FlexRow topMargin="2" justifyContent="space-between">
        <Button
          hoverColor="#A77B37"
          onClick={handleCancel}
          bgColor="#D4D4D4"
          color="#374957"
        >
          <AiOutlineClose size={17} /> Cancel
        </Button>
        <Button
          hoverBgColor="#fff"
          hoverColor="#A77B37"
          borderColor="#A77B37"
          onClick={handleSubmit}
        >
          <AiOutlineCheck size={17} /> Confirm
        </Button>
      </FlexRow>
    </Modal>
  );
};
